
import { Link } from 'react-router-dom';

export default function ServicesOverview() {
  const services = [
    {
      icon: 'ri-bank-card-line',
      title: 'Buy Tradelines',
      description:
        'Strategic authorized user tradelines designed to strengthen your credit profile and improve your fundability before applying for business or personal funding.',
      features: [
        'Authorized User Tradelines',
        'Aged High-Limit Accounts',
        'Profile Strengthening Strategy',
        'Posting Window Coordination',
        'Inventory-Based Availability',
        'Fundability-Focused Placement',
      ],
      link: '/buy-tradelines',
    },
    {
      icon: 'ri-user-line',
      title: 'Personal Funding',
      description:
        'Personal credit optimization and funding strategies including personal loans, 0% credit cards, and profile positioning for maximum approval rates.',
      features: [
        'Personal Loans',
        '0% Personal Credit Cards',
        'Credit Profile Optimization',
        'Strategic Positioning',
        'Approval Rate Maximization',
      ],
      link: '/services',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Business Credit Building',
      description:
        'Complete business credit infrastructure including entity setup, compliance, DUNS registration, tradeline development, and fundability audits.',
      features: [
        'Entity Setup & Compliance',
        'DUNS Registration',
        'Tradeline Development',
        'Bank Account Seasoning',
        'Fundability Audits',
      ],
      link: '/services',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <p className="text-xs uppercase tracking-wider text-gray-600 mb-4 font-semibold">
            OUR SERVICES
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6">
            What We Do
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Strategic funding positioning across three core disciplines
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="bg-white rounded-xl p-10 shadow-sm hover:shadow-lg transition-shadow cursor-pointer"
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${service.icon} text-5xl text-navy`}></i>
                </div>
              </div>

              <h3 className="text-2xl font-semibold text-navy text-center mb-4">
                {service.title}
              </h3>

              <p className="text-sm text-gray-600 leading-relaxed text-center mb-6 max-w-xs mx-auto">
                {service.description}
              </p>

              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-700">
                    <div className="w-1.5 h-1.5 rounded-full bg-navy mt-2 mr-3 flex-shrink-0"></div>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center text-navy font-medium hover:text-navy-light transition-colors cursor-pointer"
          >
            View All Services
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
